module.exports = __webpack_public_path__ + "img/50_26.ab2acb5d.png";